import { Container } from '@energiebespaarders/symbols';
import Head from 'next/head';
import Link from 'next/link';
import CustomerIntakeController from '~/components/CustomerIntake/CustomerIntakeController';
import { IntakeExitProvider } from '~/components/CustomerIntake/IntakeExitContext';
import { MinimalNav, StyledLogo } from '~/components/_cmsBlocks/StyledComponents';
import { MagicLinkProvider } from '~/hooks/useMagicLink';
import type { Page } from '~/types/next';
import DEBLogo from '/public/img/logo_WEB.svg';

const SelfServiceIntake: Page = () => {
  return (
    <>
      <Head>
        <title key="title">Slimme Woningscan: gratis verduurzamingsadvies en offertes</title>
        <meta
          name="description"
          content="Vertel ons over je woning en krijg kosteloos automatische prijsindicaties. Vraag vervolgens een huisbezoek aan voor maatadvies."
        />
      </Head>

      <MinimalNav width={1} p={2}>
        <Link href="/">
          <a>
            <StyledLogo src={DEBLogo} alt="Energiebespaarders" />
          </a>
        </Link>
      </MinimalNav>

      <Container size="lg" pt={5} px={2}>
        <IntakeExitProvider>
          <CustomerIntakeController />
        </IntakeExitProvider>
      </Container>
    </>
  );
};

const SelfServiceIntakeWrapper: React.FC = props => (
  <MagicLinkProvider>
    <SelfServiceIntake {...props} />
  </MagicLinkProvider>
);

export default SelfServiceIntakeWrapper;
